<template>
	<div class="mid_scroll_content">
		<loader v-if="pageLoader"></loader>
		<!-- <section class="depoist_fund  pb-5">
			<div class="row justify-content-center">
				<div class="col-10">
					<div>
						<div class="row">
							<div class="col-12">
								<div class="add_payment_methods border-0 rounded mt-3 mb-3">
									<ul class="cpw_tab mb-4">
										<li><a id="tab1" :class="(tab == 1)?'':'inactive'" @click.prevent="tab = 1">Credit Card</a></li>
										<li><a id="tab2" :class="(tab == 2)?'':'inactive'" @click.prevent="tab = 2">Online Payment</a></li>
										<li><a id="tab3" :class="(tab == 3)?'':'inactive'" @click.prevent="tab = 3">Bank Transfer</a></li>
									</ul>
									<card-payment v-if="tab == 1"></card-payment>
									<online-payment v-if="tab == 2"></online-payment>
									<bank-payment v-if="tab == 3"></bank-payment>
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>
		</section> -->
		<section class="depoist_fund add_ipaddress pb-5 border-bottom-0 h-100">
			<div class="container h-100">
				<div class="row h-100">
					<alert-notification v-if="notification_msg != ''"/>
					<div class="personalForm list-group mb-4">
						<div v-if="GetPaymentMethods.length > 0">
							<div v-for="(bankList,index) in GetPaymentMethods">
								<div class="mb-3" v-if="parseInt(bankList.method) == 1">
									<div class="list-group-item head d-flex justify-content-between align-items-center">
										<div>
											<p class="mr-3">
												<strong>Bank Name</strong>
												<span v-html="(bankList.bank_name != '' && bankList.bank_name != null)? bankList.bank_name : '-'"></span>
											</p>
											<p>
												<strong>Account Number</strong>
												<span v-html="(bankList.account_no != '' && bankList.account_no != null)? bankList.account_no : '-'"></span>
											</p>
										</div>  
										<div class="hitMob edt">
											<a href="#" class="themeColor animate-bottom mr-3" @click="detailDiv(index);">View detail</a>
											<a href="#" class="themeColor" v-if="parseInt(bankList.status) == 2">Pending</a>
											<!-- <a href="#" class="red" @click="disable(bankList );" v-else>Disable</a> -->
										</div>
									</div>
									<div class="bottomInfo fade" :ref="'buttons'+index">
										<div class="list-group-item">
											<span> Deposit Method</span>
											<span><img class="ml-2" :src="'../../../../static/website/images/'+$env_var.withdrawalMethod[bankList.method]" width="50" alt="Bank Account"></span>
										</div>  
										<div class="list-group-item">
											<span>Account Name</span>
											<span v-html="(bankList.holder_name != '' && bankList.holder_name != null)? bankList.holder_name : '-'"></span>
										</div>
										<div class="list-group-item">
											<span>Swift/BIC/Sort Code</span>
											<span v-html="(bankList.sort_code != '' && bankList.sort_code != null)? bankList.sort_code : '-'"></span>
										</div>
										<div class="list-group-item">
											<span>IBAN</span>
											<span v-html="(bankList.micr != '' && bankList.micr != null)? bankList.micr : '-'"></span>
										</div>
										<div class="list-group-item">
											<span>Bank Address: </span>
											<span v-html="(bankList.bank_address != '' && bankList.bank_address != null)? bankList.bank_address : '-'"></span>
										</div>                               
									</div>  
								</div> 
								<div class="mb-3" v-else-if="parseInt(bankList.method) == 2">
									<div class="list-group-item head align-items-center p-0"> 
										<div class="d-flex justify-content-start align-items-center">
											<p class="mr-3 mb-0 border-right p-3 text-center">
												<span><img   :src="'../../../../static/website/images/'+$env_var.withdrawalMethod[bankList.method]" width="50" alt="Bank Account"></span>
												<br>
												<small> Deposit Method</small>
											</p> 
											<p>
												<strong>Online Payment ID:</strong>
												<span>{{bankList.online_payment_id}}</span>
											</p>
											
										</div>
										<div class="p-3 hitMob">
											<router-link :to="{name: 'support' , params: { 'tabName':'requestServiceElement','page':'profile', 'ticketData' : '16','method_id':'2'}}">Change</router-link>
										</div>
									</div> 
								</div>
								<div class="mb-3" v-else-if="parseInt(bankList.method) == 3">
									<div class="list-group-item head align-items-center p-0"> 
										<div class="d-flex align-items-center justify-content-start">
											<p class="mr-3 border-right p-3 text-center">
												<span><img   :src="'../../../../static/website/images/'+$env_var.withdrawalMethod[bankList.method]" width="50" alt="Bank Account"></span>
												<br>
												<small>Deposit Method</small>

											</p>
											<p class="mr-3">
												<strong>Online Payment ID:</strong>
												<span>{{bankList.online_payment_id}}</span>
											</p> 
										</div> 
										<div class="p-3 hitMob">
											<router-link :to="{name: 'support' , params: { 'tabName':'requestServiceElement','page':'profile', 'ticketData' : '16','method_id':'3'}}">Change</router-link>
										</div>
									</div> 
								</div>	
								<div class="mb-3" v-else-if="parseInt(bankList.method) == 5">
									<div class="list-group-item head align-items-center p-0"> 
										<div class="d-flex align-items-center justify-content-start">
											<div class="mr-3 border-right p-3 text-center">
												<span><img :src="'../../../../static/website/images/'+$env_var.withdrawalMethod[bankList.method]" width="50" alt="Bank Account"></span> <br>
												<small> Deposit Method</small>
											</div>
											<div>
												<p>
													<strong>Credit Card Number:</strong>
													<span> **** **** **** {{bankList.last_digit_card}}</span> <br>
												</p>
												<p>
													<strong>Expiry Date:</strong>
													<span> {{bankList.card_month}}/{{bankList.card_year}}</span> <br>
												</p>
											</div>
										</div> 
										<div class="p-3 hitMob">
											<a href="#" class="themeColor" v-if="parseInt(bankList.status) == 2">Pending</a>
											<!-- <a href="#" class="red" @click="disable(bankList );" v-else>Disable</a> -->
										</div>
									</div> 
								</div>
																
							</div>
						</div>
						<div class="noDetails-empty mb-4" v-else>
							<div class="list-group-items border-0 text-center">
								<span class="imageBelow">
									<img src="../../../../static/website/images/undraw_pay_online.svg" alt="Icon">
								</span>
								<h4>No Bank Detail</h4>
								<span></span>
							</div> 
						</div>
						<div class="addBank text-center mt-0">
							<a href="javascript:void(0)" class="px-3 cap_btn blue d-inline-flex align-items-center justify-content-center" :class="(pageLoader)?'disabled':''"  v-on:click="withdrawLimit()"> <feather type="home" class="mr-2"></feather> Add Bank</a>
							<!-- <router-link class="cap_btn-b" :to="{name: 'support' , params: { 'tabName':'requestServiceElement','page':'profile', 'ticketData' : '16','method_id':'5'}}"> <feather type="folder-plus"></feather> Add Credit card</router-link> -->
						</div>
					</div> 
			    </div>
		    </div>
			<!-- <div class="section_title">
				<h5>Bank Detail History</h5>
			</div>
			<div class="row justify-content-center">
				<div class="col-12 text-center">
					<div class="dataTable table-responsive">
						<table id="dtBasicExample" class="table table-striped table-bordered" width="100%">
							<thead>
								<tr>
									<th>Bank Named</th>
									<th>Account Number</th>
									<th>Uploaded Since</th>
									<th>Last Used</th>
									<th>Actions</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>Saved Bank #1</td>
									<td>1234567890</td>
									<td>3 Days ago</td>
									<td>2 mins ago</td>
									<td>
										<a class="t_ic" href="#"><feather type="x-circle"></feather></a>
										<a class="t_ic" href="#"><feather type="more-vertical"></feather></a>
									</td>
								</tr>
								<tr>
									<td>Saved Bank #1</td>
									<td>1234567890</td>
									<td>3 Days ago</td>
									<td>2 mins ago</td>
									<td>
										<a class="t_ic" href="#"><feather type="x-circle"></feather></a>
										<a class="t_ic" href="#"><feather type="more-vertical"></feather></a>
									</td>
								</tr>
								<tr>
									<td>Saved Bank #1</td>
									<td>1234567890</td>
									<td>3 Days ago</td>
									<td>2 mins ago</td>
									<td>
										<a class="t_ic" href="#"><feather type="x-circle"></feather></a>
										<a class="t_ic" href="#"><feather type="more-vertical"></feather></a>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div> -->
		</section>
	</div>
</template>

<script>
import card from './methods/card'
import online from './methods/online'
import bank from './methods/bank'
import { depositWithdrawalMixins } from '@/plugins/depositWithdrawal'
export default {
    name: 'paymentmethods',
	mixins: [depositWithdrawalMixins],
	pageLoader: false,
    data() {
        return {
			tab : 1,
			pageLoader : false,
			notification_msg:'',
            notification_type:'',
        }
	},
	components:{
		cardPayment : card,
		onlinePayment : online,
		bankPayment : bank
	},
	methods:{
		detailDiv(index) {
			if ($(this.$refs['buttons'+index]).hasClass('fade')){
				$(this.$refs['buttons'+index]).removeClass('fade');
				$(this.$refs['buttons'+index]).addClass('fade_reverse');
			}else {
				$(this.$refs['buttons'+index]).removeClass('fade_reverse');
				$(this.$refs['buttons'+index]).addClass('fade');
			}                
		},
	},
	created(){
		this.pageName('Payment Methods')
		this._runGetPaymentMethods({ 'globalParams' :{ },'localParams' :{"parameter" : this}})
	}
}
</script>



// WEBPACK FOOTER //
// src/components/website/payment/paymentmethods.vue